<template>
  <custom-dialog :title="model.title" width="800px" :visible="visible" :append-to-body="true" v-on="$listeners" class="deliver-goods-info">
    <div class="dialog-body">
      <div class="base-info">
        <el-form label-position="top">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('crm_deliver_goods_info_dialog.fa_huo_dan_hao')">
                {{ info.customShipmentNum }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('crm_deliver_goods_info_dialog.fa_huo_fang')">
                {{ info.shipperOrgName }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('crm_deliver_goods_info_dialog.shou_huo_fang')">
                {{ info.consigneeName }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('crm_deliver_goods_info_dialog.fa_huo_ri_qi')">
                {{ $momentLocal(data.gmtCreate, 'YYYY-MM-DD') }}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table height="400px" :data="info.deviceList" :column="tableColumn" :tableCode="tableCode" @filter="filterChange" @sort="sortChange" :index="true"></custom-table>
      </div>
    </div>
    <div class="dialog-footer" slot="footer">
      <el-button @click="closeDialog">{{ $t('Common.com_close') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
/** 发货详情 */
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {},
  props: {
    searchKey: {
      type: String,
      default: 'customShipmentNum',
    },
  },
  data() {
    return {
      tableCode: 'crm_deliver_goods_dialog',
      info: {
        deviceList: [],
        //  发货单号
        customShipmentNum: '',
        // 发货方
        shipperOrgName: '',
        // 收货方
        consigneeName: '',
        // 发货日期
        gmtCreate: '',
      },
    };
  },
  methods: {
    getInfo() {
      this.$getJSON(apis.orderDeliveryInfo, {
        customShipmentNum: this.model.data[this.searchKey],
      }).then((res) => {
        this.info = res.data;
      });
    },
    closeDialog() {
      this.visible = false;
    },
  },
  mounted() {
    this.getInfo();
  },
};
</script>

<style lang="scss" scoped>
.deliver-goods-info {
  .base-info {
    .el-col {
      line-height: 35px;
    }
  }
}
</style>
